const key = Symbol('ChoiceKey');

export default key;
